import { useEffect, useState } from 'react';
import { useGameState } from '../../net/GameProvider.js';
import { useI18n } from '../../i18n.js';
import { PlayerProfileModal } from './PlayerProfileModal.js';

export function LeaderboardSection() {
  const { state, actions } = useGameState();
  const { lang } = useI18n();
  const isMn = lang === 'mn';
  const [inspectedUser, setInspectedUser] = useState<{ userId: string; name: string } | null>(null);

  const isConnected = state.connectionStatus === 'connected';

  useEffect(() => {
    if (isConnected && !state.leaderboard && !state.leaderboardLoading) {
      actions.getLeaderboard();
    }
  }, [isConnected, state.leaderboard, state.leaderboardLoading, actions]);

  const entries = state.leaderboard?.entries ?? [];
  const myRank = state.leaderboard?.myRank;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        background: 'rgba(0, 0, 0, 0.35)',
        borderRadius: 12,
        border: '1px solid rgba(251, 191, 36, 0.35)',
        padding: 16,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontWeight: 800, color: '#fde68a', fontSize: '0.95em' }}>
          🏆 {isMn ? 'Шилдэг тоглогчдын жагсаалт (Top 10)' : 'Top 10 Players Leaderboard'}
        </span>
        <button
          type="button"
          onClick={() => actions.getLeaderboard()}
          style={{
            padding: '4px 10px',
            fontSize: '0.78em',
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: 6,
            color: '#fff',
            cursor: 'pointer',
            opacity: state.leaderboardLoading ? 0.65 : 1,
          }}
        >
          {state.leaderboardLoading ? (isMn ? 'Уншиж байна...' : 'Loading...') : (isMn ? 'Шинэчлэх' : 'Refresh')}
        </button>
      </div>

      {state.leaderboardLoading && entries.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '24px 0', opacity: 0.7, fontSize: '0.88em' }}>
          <div style={{ marginBottom: 6, fontSize: '1.2em' }}>⏳</div>
          {isMn ? 'Чансааг ачааллаж байна...' : 'Loading leaderboard...'}
        </div>
      ) : entries.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '24px 0', opacity: 0.85, fontSize: '0.88em' }}>
          <p style={{ margin: '0 0 10px' }}>
            {isMn ? 'Одоогоор жагсаалтад тоглогч бүртгэгдээгүй байна.' : 'No leaderboard entries yet.'}
          </p>
          <button
            type="button"
            onClick={() => actions.getLeaderboard()}
            style={{
              padding: '6px 14px',
              fontSize: '0.82em',
              background: 'rgba(251, 191, 36, 0.18)',
              border: '1px solid rgba(251, 191, 36, 0.4)',
              borderRadius: 6,
              color: '#fde68a',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            {isMn ? '🔄 Дахин ачааллах' : '🔄 Retry'}
          </button>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '0.84em',
              textAlign: 'left',
            }}
          >
            <thead>
              <tr style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.18)', opacity: 0.8 }}>
                <th style={{ padding: '6px 8px' }}>#</th>
                <th style={{ padding: '6px 8px' }}>{isMn ? 'Тоглогч' : 'Player'}</th>
                <th style={{ padding: '6px 8px', textAlign: 'center' }}>{isMn ? 'Хожил' : 'Wins'}</th>
                <th style={{ padding: '6px 8px', textAlign: 'center' }}>{isMn ? 'Нийт' : 'Played'}</th>
                <th style={{ padding: '6px 8px', textAlign: 'right' }}>{isMn ? 'Цай' : 'Tsai'}</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((entry) => {
                const isMe = state.profile && entry.userId === state.profile.id;
                const medal = entry.rank === 1 ? '🥇' : entry.rank === 2 ? '🥈' : entry.rank === 3 ? '🥉' : `${entry.rank}`;
                return (
                  <tr
                    key={entry.userId}
                    style={{
                      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
                      background: isMe ? 'rgba(251, 191, 36, 0.12)' : 'transparent',
                    }}
                  >
                    <td style={{ padding: '8px 8px', fontWeight: 800 }}>{medal}</td>
                    <td style={{ padding: '8px 8px' }}>
                      <span
                        onClick={() => setInspectedUser({ userId: entry.userId, name: entry.displayName })}
                        style={{
                          fontWeight: isMe ? 800 : 600,
                          color: isMe ? '#fde68a' : '#fff',
                          cursor: 'pointer',
                          textDecoration: 'underline',
                          textDecorationColor: 'rgba(255, 255, 255, 0.25)',
                        }}
                        title={isMn ? `${entry.displayName} профайл үзэх` : `View ${entry.displayName}'s profile`}
                      >
                        {entry.tier === 'paid' ? '👑 ' : ''}
                        {entry.displayName}
                      </span>
                      {entry.level ? (
                          <span
                            style={{
                              marginLeft: 6,
                              fontSize: '0.75em',
                              fontWeight: 800,
                              padding: '1px 5px',
                              borderRadius: 4,
                              background: 'rgba(56, 189, 248, 0.2)',
                              color: '#38bdf8',
                              border: '1px solid rgba(56, 189, 248, 0.4)',
                            }}
                          >
                            Lv.{entry.level}
                          </span>
                        ) : null}
                        {isMe && <span style={{ opacity: 0.7, fontSize: '0.85em', marginLeft: 4 }}>({isMn ? 'Би' : 'You'})</span>}
                        {state.profile && !isMe && (
                          (() => {
                            const isFriend = state.friendsData?.friends.some((f) => f.userId === entry.userId);
                            const isPending = state.friendsData?.outgoingRequests.some((r) => r.toUserId === entry.userId);
                            if (isFriend) {
                              return (
                                <span
                                  title={isMn ? 'Найз' : 'Friend'}
                                  style={{ marginLeft: 6, fontSize: '0.75rem', opacity: 0.8 }}
                                >
                                  👥
                                </span>
                              );
                            }
                            if (isPending) {
                              return (
                                <span
                                  title={isMn ? 'Хүсэлт илгээсэн' : 'Request pending'}
                                  style={{ marginLeft: 6, fontSize: '0.72rem', color: '#fde047' }}
                                >
                                  ⏳
                                </span>
                              );
                            }
                            return (
                              <button
                                type="button"
                                onClick={() => actions.sendFriendRequest({ toUserId: entry.userId })}
                                title={isMn ? 'Найзаар нэмэх' : 'Add Friend'}
                                style={{
                                  marginLeft: 6,
                                  background: 'rgba(255, 255, 255, 0.08)',
                                  border: '1px solid rgba(255, 255, 255, 0.2)',
                                  borderRadius: 4,
                                  color: '#fff',
                                  padding: '1px 6px',
                                  fontSize: '0.72rem',
                                  cursor: 'pointer',
                                }}
                              >
                                ➕
                              </button>
                            );
                          })()
                        )}
                    </td>
                    <td style={{ padding: '8px 8px', textAlign: 'center', fontWeight: 700, color: '#4ade80' }}>
                      {entry.wins}
                    </td>
                    <td style={{ padding: '8px 8px', textAlign: 'center', opacity: 0.8 }}>
                      {entry.gamesPlayed}
                    </td>
                    <td style={{ padding: '8px 8px', textAlign: 'right', color: '#fbbf24', fontWeight: 700 }}>
                      🍵 {entry.tsaiBalance}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {myRank && (
        <div
          style={{
            marginTop: 4,
            padding: '8px 12px',
            background: 'rgba(251, 191, 36, 0.15)',
            border: '1px solid rgba(251, 191, 36, 0.35)',
            borderRadius: 8,
            fontSize: '0.82em',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span style={{ color: '#fde68a' }}>{isMn ? 'Таны эзэлж буй байр:' : 'Your current ranking:'}</span>
          <span style={{ fontWeight: 900, color: '#fff' }}>#{myRank}</span>
        </div>
      )}

      {inspectedUser && (
        <PlayerProfileModal
          userId={inspectedUser.userId}
          initialPlayerName={inspectedUser.name}
          onClose={() => setInspectedUser(null)}
        />
      )}
    </div>
  );
}
